<template>
  <div class="container section">
    <back-navigation />
    <promised :promise="postPromise" v-slot:combined="{ isPending, data }">
      <div class="columns">
        <div class="column is-4 tw-mt-6">
          <skeleton-loading v-if="isPending" />
          <scrapbook-card
            @report="onPostReported"
            v-if="data"
            :post="data"
            full
          />
        </div>
        <div class="column lg:tw-pl-16">
          <div class="section-block">
            <span class="title">COMMENTS & DISCUSSION</span>
          </div>

          <comment v-if="data" :model="data" />
        </div>
      </div>
    </promised>

    <report-modal ref="reportPost" :item="reportedPost" />
  </div>
</template>

<script>
import ReportModal from '@/components/modals/Report'
import BackNavigation from '@/components/BackNavigation'
import ScrapbookCard from '@/components/ScrapbookCard'
import Comment from '@/components/comment'
import Post from '@/models/Post'

export default {
  components: {
    ScrapbookCard,
    BackNavigation,
    Comment,
    ReportModal
  },
  data() {
    return {
      reportedPost: null,
      postPromise: null
    }
  },
  created() {
    this.getPost()
  },
  methods: {
    getPost() {
      this.postPromise = Post.include('user', 'image')
        .$find(this.$route.params.id)
        .catch(() => {
          this.$router.replace({ name: 'student-hub' })
        })
    },

    onPostReported(post) {
      this.reportedPost = post
      this.$refs.reportPost.open()
    }
  }
}
</script>
